// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FRT7h","toggleWrap":"styles_toggleWrap__28-6u","content":"styles_content__AVvQ8","selectAreaCode":"styles_selectAreaCode__e_STr"};